import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"จดทะเบียนบริษัทจำกัดในไทย — Thai Company Registration","metaTitle":"จดบริษัทจำกัดไทย — Thai Company Registration ครบวงจร | NYC","metaDesc":"จดทะเบียนบริษัทจำกัด/หจก. ไทย ต่างชาติถือหุ้น 49/51 หรือ 100% BOI/US Treaty ยื่น DBD/RD/SSO — เริ่มต้นง่าย ๆ แค่ทักไลน์ เราดูแลจนจบทุกขั้นตอน"},"en":{"h1":"Thai Company Registration — Limited Company Setup End-to-End","metaTitle":"Thai Company Registration — Ltd, BOI 100% Foreign, US Amity | NYC","metaDesc":"Thai limited company registration in 7 days. 49/51 or 100% foreign via BOI / US Treaty of Amity. Full DBD — Start with a free review before you file anything."}} as const;

export const Route = createFileRoute("/corporate/company-registration")({
  head: () => {
    const url = `${SEO_SITE}/corporate.company-registration`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/corporate/company-registration", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/corporate/company-registration", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/corporate/company-registration", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/corporate/company-registration", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/corporate.company-registration", "/en/corporate.company-registration")],
    };
  },
  component: () => <SubServicePage slug="corporate/company-registration" locale="th" />,
});
